// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"jq-z","slideIn":"kq-z"};